<template>
<q-page class="signup" :class="{'bg-white': !$isDesktop}">
  <div class="row justify-center items-center" :class="$isDesktop ? 'q-pa-xl' : 'q-pa-md'">
    <q-card v-if="$isDesktop" class="col-6">
      <common-form action="/user/confirm-password">
        <q-card-section class="q-pa-lg q-gutter-lg">
          <p>Om deze actie uit te voeren moet u uw wachtwoord opnieuw opgeven</p>
          <common-input name="password"
                        v-model="form.password"
                        label="Wachtwoord"
                        type="password"
                        :error-message="$errorMessage('password')"
                        :error="$hasError('password')"
          />
        </q-card-section>
        <q-separator />
        <q-card-actions align="between" class="q-py-md q-px-lg">
          <accent-button type="submit" label="Bevestig wachtwoord" />
        </q-card-actions>
      </common-form>
    </q-card>
    <div v-else class="col-xs-12 col-sm-10 q-mt-lg">
      <common-form action="/user/confirm-password">
        <div class="row q-col-gutter-lg">
          <p>Om deze actie uit te voeren moet u uw wachtwoord opnieuw opgeven</p>
          <common-input name="password"
                        v-model="form.password"
                        label="Wachtwoord"
                        type="password"
                        class="col-12"
                        :error-message="$errorMessage('password')"
                        :error="$hasError('password')"
          />
        </div>
        <q-separator />
        <div class="row justify-between q-mt-md">
          <accent-button type="submit" label="Bevestig wachtwoord" />
        </div>
      </common-form>
    </div>
  </div>
</q-page>
</template>

<script>
export default {
  data () {
    return {
      form: {
        password: '',
      },
    }
  },
}
</script>
